export let settings = {
  apiUrl: 'https://api.pjo.martitom.ch'
}



// WEBPACK FOOTER //
// ./src/assets/settings.js